import { render, staticRenderFns } from "./DimensionExtItem.vue?vue&type=template&id=e55dcd88&scoped=true&"
import script from "./DimensionExtItem.vue?vue&type=script&lang=js&"
export * from "./DimensionExtItem.vue?vue&type=script&lang=js&"
import style0 from "./DimensionExtItem.vue?vue&type=style&index=0&id=e55dcd88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55dcd88",
  null
  
)

export default component.exports